import { render } from "./collect.vue?vue&type=template&id=58b4e4c4&scoped=true"
import script from "./collect.vue?vue&type=script&lang=js"
export * from "./collect.vue?vue&type=script&lang=js"

import "./collect.vue?vue&type=style&index=0&id=58b4e4c4&scoped=true&lang=css"

import exportComponent from "D:\\javaScript\\ezhai_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b4e4c4"]])

export default __exports__